<template>
  <div class="youtaofang">
    <topTitle
      title="柏庭荟"
      :list="list"
      :newData="newData"
      :ContentStatus="ContentStatus"
      :remakTitle="remakTitle"
    ></topTitle>
    <p class="top_p">
      钱湖柏庭健身俱乐部有4个社团，分别是禅舞社团、佳木斯社团、柔力球社团、太极社团。
    </p>
    <p class="top_p title" style="margin: 0">一、禅舞社团</p>
    <p class="top_p" style="margin: 0">
      禅舞，顾名思意便是禅和舞，禅舞本身就是一个禅创，起心动念便是学习禅舞最重要的一点了。
    </p>
    <p class="top_p" style="margin: 0">
      柏庭的禅舞社团开设以来便受到了不少长者们的追捧，借由禅舞，获得内在智慧，获得长久友谊。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/jianshen.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">二、佳木斯社团</p>
    <p class="top_p" style="margin: 0">
      佳木斯的舞步快乐而充满活力，可以说是非常适合长者们的，在这样一个活泼的氛围，想不年轻都难呢~
    </p>
    <p class="top_p" style="margin: 0">
      佳木斯社团更是柏庭长者们不约而同的选择，唱吧，跳吧，谁能阻挡我们快乐的步伐！
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/jianshen_1.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">三、柔力球社团</p>
    <p class="top_p" style="margin: 0">
      以你为圆心，以健身健康为半经，每天画圆画弧，围绕你旋转不停......
    </p>
    <p class="top_p" style="margin: 0">
      这便是柔力球的魅力了，能让大家聚集在同一个社团，真是缘分，妙不可言。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/jianshen_2.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">四、太极社团</p>
    <p class="top_p" style="margin: 0">
      动中有静，如溪流潺潺，静中有动，似江水滔滔。西方人称之为“东方芭蕾”，而中国人则称之为——太极。
    </p>
    <p class="top_p" style="margin: 0">
      在柏庭太极社团，总能看到那么一群人，他们有着优美连绵的体态，宛如霞光中起舞的仙鹤......
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/jianshen_3.jpg" alt="" />
    </div>
    
    <!-- <p class="top_p" v-if="ContentStatus==false">
     读书，对于大多数人来讲是一种爱好，更是一种享受,一种源于生活、出于内心的享受。
    </p>
    <p class="top_p" style="margin:0" v-if="ContentStatus==false">
      只要您喜爱阅读，喜爱文学创作，达到法定退休年龄，愿同我们一起泛舟书海，在阅读的同时创作更多优秀的文学作品，用文字记载岁月、抒发情感、结交知己，分享阅读和写作过程中的所思所感。我们愿为钱湖柏庭老年读书俱乐部所有会员搭建分享、交流的平台。俱乐部服务内容包括：优秀文学书籍推荐、珍稀书籍展、不定期组织读书分享会、作家见面会（和名家近距离交流，有机会得到作家签名赠书）、柏庭荟刊物编辑及作品刊登、协助俱乐部成员作品发表及出版等活动。
    </p>
     <p class="top_p" style="margin:0" v-if="ContentStatus==false">
      书香致远·悦读人生”——“我理想中的晚年生活”征文比赛颁奖暨钱湖柏庭老年读书俱乐部成立仪式在钱湖柏庭展厅成功举办，在“我理想中的晚年生活”征文活动中获奖的长者们和此次征文比赛的专家评委齐聚展厅，共同见证了各奖项的颁发以及钱湖柏庭老年读书俱乐部的成立。
    </p>
    <div class="item_bd" v-if="ContentStatus==false">
      <img :src="item.img" alt="" v-for="(item, key) in list2" :key="key" />
    </div>
     <div href="" class="navGet" @click="getHtml('6')" v-if="ContentStatus==false">“我理想中的晚年生活”征文比赛颁奖典礼成功举办<div class="small_jiantou item_jiantou1"></div><div class="small_jiantou item_jiantou2"></div></div>
     <p v-html="dataContent" v-if="ContentStatus"></p> -->
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
        },
        {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
        },
        {
          title: "文艺俱乐部",
          hasTitle: "文艺俱乐部",
        },
        {
          title: "休闲俱乐部",
          hasTitle: "休闲俱乐部",
        },
        {
          title: "健身俱乐部",
          hasTitle: "健身俱乐部",
        },
        {
          title: "桌游俱乐部",
          hasTitle: "桌游俱乐部",
        },
        {
          title: "声乐俱乐部",
          hasTitle: "声乐俱乐部",
        },
        {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
        },
        {
          title: "外语俱乐部",
          hasTitle: "外语俱乐部",
        },
        {
          title: "园艺俱乐部",
          hasTitle: "园艺俱乐部",
        },
      ],
      newData: 4,
      list2: [
        {
          img: require("../../assets/image/party/dushu_1.png"),
        },
        {
          img: require("../../assets/image/party/dushu_2.png"),
        },
        {
          img: require("../../assets/image/party/dushu_3.png"),
        },
      ],
      dataContent: "",
      ContentStatus: false,
      remakTitle: "",
    };
  },
  methods: {
    getHtml(e) {
      this.$router.push({
        path: "/Meeting/getlist",
        query: { majorName: e },
      });
    },
  },
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {},
};
</script>
<style scoped="scoped">
.title {
  font-weight: 800 !important;
}
p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
}
.youtaofang {
  width: 100%;
  height: 100%;
  text-align: left;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  /* height: 3.0125rem; */
  border-radius: 0.125rem;
}
.navGet {
  display: inline-block;
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 500;
  text-decoration: underline;
  color: #3f674b;
  line-height: 54px;
  text-align: left;
  margin-top: 0.6rem;
  cursor: pointer;
}
.small_jiantou {
  display: inline-block;
  width: 0.1rem;
  height: 0.1875rem;
  background-image: url("../../assets/image/left_item1.png");
  background-size: 100% 100%;
}
.item_jiantou1 {
  margin-left: 0.125rem;
  margin-right: 0.05rem;
}
.item_jiantou2 {
  background-image: url("../../assets/image/left_item2.png");
  background-size: 100% 100%;
}
.item_img {
  width: 100%;
  padding: 0.5625rem 0.3rem;
}
.item_img > img {
  width: 100%;
  height: auto;
}
</style>